export const actions = {
  HORARIOS_ENTREGA_MOSTRAR_TODO_LOAD_REQUESTED: 'HORARIOS_ENTREGA_MOSTRAR_TODO_LOAD_REQUESTED',
  HORARIOS_ENTREGA_MOSTRAR_TODO_LOAD_SUCCEEDED: 'HORARIOS_ENTREGA_MOSTRAR_TODO_LOAD_SUCCEEDED',
  HORARIOS_ENTREGA_MOSTRAR_TODO_LOAD_FAILED: 'HORARIOS_ENTREGA_MOSTRAR_TODO_LOAD_FAILED',

  HORARIOS_ENTREGA_BY_UBICACION_ID_LOAD_REQUESTED:
    'HORARIOS_ENTREGA_BY_UBICACION_ID_LOAD_REQUESTED',
  HORARIOS_ENTREGA_BY_UBICACION_ID_LOAD_SUCCEEDED:
    'HORARIOS_ENTREGA_BY_UBICACION_ID_LOAD_SUCCEEDED',
  HORARIOS_ENTREGA_BY_UBICACION_ID_LOAD_FAILED: 'HORARIOS_ENTREGA_BY_UBICACION_ID_LOAD_FAILED',
}

export const getHorariosEntregaMostrarTodo = (dispatch, mostrarTodo) => {
  dispatch({
    type: actions.HORARIOS_ENTREGA_MOSTRAR_TODO_LOAD_REQUESTED,
    payload: mostrarTodo,
  })
}

export const getHorariosEntregabyUbicacionId = (dispatch, horarioEntregaForm) => {
  dispatch({
    type: actions.HORARIOS_ENTREGA_BY_UBICACION_ID_LOAD_REQUESTED,
    payload: horarioEntregaForm,
  })
}
